import { MenuItem, TextField } from '@mui/material'
import React from 'react'

const Dropdown = ({
  label,
  onChange,
  value,
  disabled,
  options,
  customer,
  dropdown,
  required,
  error,
}) => {
  const isLockedLeadImport =
    dropdown?.key === 'leadSource' && customer?.isLeadImport

  return (
    <TextField
      error={required && error}
      required={required}
      margin='dense'
      fullWidth
      label={label}
      value={isLockedLeadImport ? '__LEAD_IMPORT__' : value || ''}
      onChange={(e) => onChange(e.target.value)}
      select
      disabled={isLockedLeadImport || disabled}
    >
      {isLockedLeadImport && (
        <MenuItem value={'__LEAD_IMPORT__'}>Website Lead Import</MenuItem>
      )}

      {options.length === 0 && <MenuItem disabled>No options defined</MenuItem>}
      {options.length > 0 && <MenuItem value={''}>None</MenuItem>}
      {options
        .filter((o) => !!o.name)
        .map((o, i) => (
          <MenuItem key={i} value={o.id}>
            {o.name}
          </MenuItem>
        ))}
    </TextField>
  )
}

export default Dropdown
